import React, { useState } from 'react'
import { css } from '@emotion/css'
import { theme } from '../../../../styled'
import { AttackEventNoteHistoryItem } from './attack-event-discussion-note'
import { BubbleTextArea } from '../../../../legacy-design-system/form-text/bubble-text-area'
import { QueryAttackEventNotes } from './actions/query-attack-event-notes'
import { AttackEventNote } from '../../../../graphql/schema/types/attack-event-note'
import { MutationCreateAttackEventNote } from './actions/create-attack-event-note-mutation'
import { FormattedMessage } from 'react-intl'
import { I18nConsumer } from '../../../i18n-provider'
import { Button } from '@contrast-security-inc/design-system-buttons'

const cssHistoryChildrenMarginBottom = css`
  > * {
    margin-bottom: ${theme.space[2]}px;
  }
  > *:last-child {
    margin-bottom: 0;
  }
`

const cssAddNoteButton = css`
  margin-top: ${theme.space[1]}px;
  margin-bottom: ${theme.space[2]}px;
`

const cssNewAttackTextAreaContainer = css`
  padding: 0;
`

export interface AttackEventDiscussionProps {
  readonly organizationId: string
  readonly attackEventUuid: string
  readonly refreshDiscussionCount: (number) => void
}

export interface AttackEventNoteHistoryItemProps {
  readonly organizationId: string
  readonly attackEventUuid: string
  readonly attackEventNote: AttackEventNote
}

function AttackEventDiscussionAddNote({
  organizationId,
  attackEventUuid
}: AttackEventDiscussionProps) {
  const [draftNote, setDraftNote] = useState('')
  const onTextChange = (e) => setDraftNote(e)

  return (
    <React.Fragment>
      <I18nConsumer>
        {({ intl }) => {
          return (
            <BubbleTextArea
              placeholder={intl.formatMessage({ id: 'detail_postComment' })}
              expand={true}
              value={draftNote}
              onChange={onTextChange}
              classNameFormTextPrimaryContainer={cssNewAttackTextAreaContainer}
            />
          )
        }}
      </I18nConsumer>
      <MutationCreateAttackEventNote>
        {(createNote) => {
          return (
            <Button
              className={cssAddNoteButton}
              onClick={async () => {
                await createNote({
                  variables: {
                    organizationId,
                    attackEventUuid,
                    note: draftNote
                  }
                })
                setDraftNote('')
              }}
              isDisabled={!draftNote}
            >
              <FormattedMessage id="action_addComment" />
            </Button>
          )
        }}
      </MutationCreateAttackEventNote>
    </React.Fragment>
  )
}

function AttackEventDiscussionHistory({
  organizationId,
  attackEventUuid,
  refreshDiscussionCount
}: AttackEventDiscussionProps) {
  return (
    <QueryAttackEventNotes
      organizationId={organizationId}
      attackEventUuid={attackEventUuid}
    >
      {(attackEventNotes: AttackEventNote[]) => {
        refreshDiscussionCount(attackEventNotes ? attackEventNotes.length : 0)
        return (
          <div className={cssHistoryChildrenMarginBottom}>
            {attackEventNotes &&
              attackEventNotes.map((note) => {
                return (
                  <AttackEventNoteHistoryItem
                    key={note.id}
                    organizationId={organizationId}
                    attackEventUuid={attackEventUuid}
                    attackEventNote={note}
                  />
                )
              })}
          </div>
        )
      }}
    </QueryAttackEventNotes>
  )
}

export function AttackEventDiscussion(props: AttackEventDiscussionProps) {
  return (
    <div>
      <AttackEventDiscussionAddNote {...props} />
      <AttackEventDiscussionHistory {...props} />
    </div>
  )
}
